module.exports = "/templates/telerikreportviewer.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/telerikreportviewer.html
// module id = 919
// module chunks = 0